import { cn } from "../../../helpers/utils";

const ExportLoginButton = ({ label, className, icon, ...props }) => {
  return (
    <button
      type="button"
      className={cn(
        "w-full h-[48px] rounded-md border",
        "flex items-center justify-center gap-[8px] pl-[16px] pr-[8px]",
        "text-[14px] leading-6 font-normal",
        "transition-colors hover:bg-[#EEE] focus:outline-none focus:ring-2 focus:ring-[#EDEDED]/60",
        className
      )}
      {...props}
    >
      {icon}
      <span className="text-center">{label}</span>
    </button>
  );
};

export default ExportLoginButton;
